import { useEffect, useState } from "react";
import axios from "axios";
import { Activity } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LABEL = { coach: "Coach (site chat)", luma: "Luma (companion)", reflect: "Reflect on my week" };

const Row = ({ id, label, s, primary, fallback }) => {
  const warn = s.total >= 5 && s.fallback_pct >= 20;
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 py-3 border-b border-[#E7DFD5] last:border-0" data-testid={`model-health-${id}`}>
      <div>
        <div className="text-sm text-[#1C1917]">{label}</div>
        <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-[#A8A29E]">{s.total} repl{s.total === 1 ? "y" : "ies"} · primary {primary}</div>
      </div>
      <div className="flex items-center gap-4">
        {Object.entries(s.by_model).map(([m, n]) => (
          <span key={m} className="font-mono text-[10px] tracking-[0.15em] uppercase text-[#78716C]" data-testid={`model-health-${id}-${m}`}>{m.replace("claude-sonnet-4-6", "Claude").replace("gemini-3.5-flash", "Gemini").replace("unknown", "before tracking")} <span className="text-[#1C1917]">{n}</span></span>
        ))}
        <span className={`font-mono text-[10px] tracking-[0.15em] uppercase ${warn ? "text-red-400" : s.fallback_pct > 0 ? "text-[#B45309]" : "text-emerald-400"}`} data-testid={`model-health-${id}-fallback`} title={`Backup (${fallback}) answered ${s.fallback_pct}% of the time`}>
          backup {s.fallback_pct}%
        </span>
      </div>
    </div>
  );
};

export const ModelHealth = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/admin/models/health`).then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  return (
    <section className="tacc-card p-5 md:p-6" data-testid="model-health">
      <div className="section-tag mb-1 flex items-center gap-2"><Activity size={12} /> § Who answered · last 7 days</div>
      <p className="text-xs text-[#A8A29E] mb-3">Claude is the voice. Gemini only steps in when Claude fails or stalls — if "backup" climbs past 20%, Claude is struggling. Reflections run on Gemini with Claude as backup. Counting only; no model calls.</p>
      <Row id="coach" label={LABEL.coach} s={d.surfaces.coach} primary="Claude" fallback="Gemini" />
      <Row id="luma" label={LABEL.luma} s={d.surfaces.luma} primary="Claude" fallback="Gemini" />
      <Row id="reflect" label={LABEL.reflect} s={d.surfaces.reflect} primary="Gemini" fallback="Claude" />
    </section>
  );
};
